import { Step, StepLabel, Stepper, Typography } from '@mui/material';
import { FORM_STEPS } from '@pages/SavingsCalculator/constants/FormSteps';
import { FormStepperProps, ValueByStep } from '@pages/SavingsCalculator/types';
import { useTranslation } from 'react-i18next';
import PeopleStep from '../Form/PeopleStep';
import ProvidersStep from '../Form/ProvidersStep';
import VolumeStep from '../Form/VolumeStep';

const FormStepper = ({
  activeStep,
  values,
  setStepValue,
}: FormStepperProps) => {
  const { t } = useTranslation();
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {FORM_STEPS.map((step, index) => (
        <Step
          expanded
          key={step}
          sx={{
            '& .MuiStepLabel-root .Mui-completed': {
              color: '#006BF8',
            },
            '& .MuiStepLabel-root .Mui-active': {
              color: '#006BF8',
            },
          }}
        >
          <StepLabel>
            <Typography
              className={activeStep === index ? '!text-[#00143A]' : ''}
            >
              {t(`svngsStep${index + 1}Title`)}
            </Typography>
          </StepLabel>
          {index === ValueByStep.volume ? (
            <VolumeStep values={values} setStepValue={setStepValue} />
          ) : null}
          {index === ValueByStep.providers ? (
            <ProvidersStep values={values} setStepValue={setStepValue} />
          ) : null}
          {index === ValueByStep.people ? (
            <PeopleStep values={values} setStepValue={setStepValue} />
          ) : null}
        </Step>
      ))}
    </Stepper>
  );
};

export default FormStepper;
